var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFriendWhite = function SvgIconFriendWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-friends-active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-317.159 -274.449)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M319.159 294.937v3.512h20v-3.512c0-3.578-4.485-6.488-10-6.488s-10 2.91-10 6.488Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(323.159 274.449)"
  }))));
};
export { SvgIconFriendWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1mcmllbmRzLWFjdGl2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI2ZmZiIgb3BhY2l0eT0iMCIvPgogIDxnIGlkPSJHcm91cF8yNyIgZGF0YS1uYW1lPSJHcm91cCAyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMxNy4xNTkgLTI3NC40NDkpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzEyMCIgZGF0YS1uYW1lPSJQYXRoIDEyMCIgZD0iTTMxOS4xNTksMjk0LjkzN3YzLjUxMmgyMHYtMy41MTJjMC0zLjU3OC00LjQ4NS02LjQ4OC0xMC02LjQ4OFMzMTkuMTU5LDI5MS4zNTksMzE5LjE1OSwyOTQuOTM3WiIgZmlsbD0iI2ZmZiIvPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8zMCIgZGF0YS1uYW1lPSJFbGxpcHNlIDMwIiBjeD0iNiIgY3k9IjYiIHI9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMyMy4xNTkgMjc0LjQ0OSkiIGZpbGw9IiNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo=";